/** Word-level IPA overrides for Japanese. */
export const ja: Record<string, string> = {
  あけぼの: '/akebono/',
  あった: '/atːa/',
  あと: '/ato/',
  あまた: '/amata/',
  あらぬ: '/aɾanɯ/',
  あり: '/aɾi/',
  ある: '/aɾɯ/',
  あるく: '/aɾɯkɯ/',
  いう: '/iɯ/',
  イギリス: '/iɡiɾisɯ/', // England
  いた: '/ita/',
  いたう: '/itaɯ/', // archaic: greatly
  // New sample overrides
  いつも: '/itsɯmo/',
  いづれ: '/idɯɾe/', // archaic: which
  いる: '/iɾɯ/',
  うみ: '/ɯmi/',
  うら: '/ɯɾa/',
  おる: '/oɾɯ/',
  かた: '/kata/',
  かたち: '/katatɕi/',
  かつぐ: '/katsɯɡɯ/',
  かの: '/kano/',
  く: '/kɯ/', // archaic verb stem
  ご: '/ɡo/',
  ここ: '/koko/',
  ございます: '/ɡozaimasɯ/',
  この: '/kono/',
  さざれ: '/sazaɾe/',
  さびしい: '/sabiɕiː/',
  さら: '/saɾa/', // archaic: furthermore
  しよう: '/ɕijoː/',
  すぐれる: '/sɯɡɯɾeɾɯ/',
  すこし: '/sɯkoɕi/',
  する: '/sɯɾɯ/',
  そこ: '/soko/',
  その: '/sono/',
  だいぶ: '/daibɯ/',
  だけ: '/dake/',
  ただ: '/tada/',
  だつ: '/datsɯ/', // archaic suffix: -ish
  たなびく: '/tanabikɯ/',
  つく: '/tsɯkɯ/',
  つれる: '/tsɯɾeɾɯ/',
  どこ: '/doko/',
  ところ: '/tokoɾo/',
  とらえる: '/toɾaeɾɯ/',
  なお: '/nao/',
  なか: '/naka/',
  なく: '/nakɯ/',
  なった: '/natːa/',
  なびく: '/nabikɯ/',
  のけ: '/noke/',
  ばかり: '/bakaɾi/',
  はた: '/hata/',
  ハンブルク: '/hambɯɾɯkɯ/',
  ふう: '/ɸɯː/',
  ふち: '/ɸɯtɕi/',
  ほか: '/hoka/',
  ほど: '/hodo/',
  ほんとう: '/hontoː/',
  また: '/mata/',
  まだ: '/mada/',
  まで: '/made/',
  みなさん: '/minasaɴ/',
  みんな: '/minːa/',
  むす: '/mɯsɯ/',
  メロス: '/meɾosɯ/',
  やうやう: '/jaɯjaɯ/', // archaic: gradually
  やみ: '/jami/',
  やむ: '/jamɯ/',
  やんごとなし: '/jaŋɡotonaɕi/', // archaic: noble
  よく: '/jokɯ/',
  よほど: '/johodo/',
  る: '/ɾɯ/', // classical auxiliary
  わかる: '/wakaɾɯ/',
  一茶: '/itːɕa/', // Issa (poet)
  三十七: '/saɴdʑɯːɕitɕi/',

  候う: '/soːɾoː/', // archaic polite auxiliary
  呼んで: '/joɴde/',
  憚: '/habaka/', // kun'yomi reading (as in 憚る)
  止: '/to/', // kun'yomi reading (as in 止まる)
  止まった: '/tomatːa/',
  痩: '/jase/', // thin
  白く: '/ɕiɾokɯ/',
  知って: '/ɕitːe/',
  積み: '/tsɯmi/',
  羅生門: '/ɾaɕoːmoɴ/', // Rashomon
  舞鶴: '/maizɯɾɯ/', // Maizuru (place)
  金閣: '/kiɴkakɯ/', // Golden Pavilion
  静かさ: '/ɕizɯkasa/',
};
